import React from 'react';
import { Box, Typography } from '@mui/material';
import { LEARNING_PROGRAM_STATUS } from '../../../utils/constants';

/**
 * Draft / Published status badge for a learning program.
 * `status` is a numeric enum (see LEARNING_PROGRAM_STATUS) — only PUBLISHED renders
 * as "Published"; any other value (including future in-between states like "In Review")
 * is treated as not-yet-published and shown as "Draft" for now.
 * A compact pill (dot + label) rather than a full MUI Chip — reads cleanly
 * inline next to a program name without adding excess height/width.
 */
const ProgramPublishBadge = ({ status, style }) => {
    const isPublished = Number(status) === LEARNING_PROGRAM_STATUS.PUBLISHED;
    const color = isPublished ? '#2e7d32' : '#9E7B00';
    const bg = isPublished ? 'rgba(46, 125, 50, 0.1)' : 'rgba(158, 123, 0, 0.1)';
    return (
        <Box
            component="span"
            style={style}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                flexShrink: 0,
                height: '20px',
                padding: '0 8px',
                borderRadius: '10px',
                backgroundColor: bg,
                whiteSpace: 'nowrap',
                lineHeight: 1,
            }}
        >
            <Box
                component="span"
                sx={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    flexShrink: 0,
                }}
            />
            <Typography
                component="span"
                sx={{
                    fontSize: '10px',
                    fontWeight: 700,
                    letterSpacing: '0.4px',
                    textTransform: 'uppercase',
                    color,
                    lineHeight: 1,
                }}
            >
                {isPublished ? 'Published' : 'Draft'}
            </Typography>
        </Box>
    );
};

export default ProgramPublishBadge;
